import { Component } from '@angular/core';
import { UtilsTabsComponent } from '../../components/utils-tabs/utils-tabs.component';

@Component({
  selector: 'app-archive',
  standalone: true,
  templateUrl: './archive.component.html',
  imports: [UtilsTabsComponent],
  styleUrl: './archive.component.scss'
})
export class ArchiveComponent {}
